import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/security/templates";

export class DeleteTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";
    params: DeleteTemplateReqData = null;

    constructor(templateId: number) {
        super();
        this.params = new DeleteTemplateReqData(templateId);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class DeleteTemplateReqData {
    templateId: number;

    constructor(templateId: number) {
        this.templateId = templateId;
    }
}
